import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AnnouncementPopup from './components/AnnouncementPopup';
import HomePage from './pages/HomePage';
import BusinessListings from './pages/BusinessListings';
import BusinessDetails from './pages/BusinessDetails';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FirebaseTest from './components/FirebaseTest';
import SellBusiness from './pages/SellBusiness';
import SignIn from './pages/SignIn';
import AccountDashboard from './pages/AccountDashboard';
import { AuthProvider } from './contexts/AuthContext';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminListings from './pages/AdminListings';
import AdminMessages from './pages/AdminMessages';
import AdminUserDetail from './pages/AdminUserDetail';
import AdminUserEdit from './pages/AdminUserEdit';
import AdminListingEdit from './pages/AdminListingEdit';
import AdminConversationView from './pages/AdminConversationView';
import BrokeragesList from './pages/BrokeragesList';
import BrokerOfRecordList from './pages/BrokerOfRecordList';
import BrokersLanding from './pages/BrokersLanding';
import DDFSyncTest from './pages/DDFSyncTest';
import EditListing from './pages/EditListing';
import ListingSubmissionSuccess from './pages/ListingSubmissionSuccess';
import SavedListings from './pages/SavedListings';

function AppContent() {
  const location = useLocation();
  const isSellBusinessPage = location.pathname === '/sell-business';
  const isSignInPage = location.pathname === '/signin';
  const isYhPage = location.pathname.startsWith('/yh/');
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  // Show announcement popup on every page load, except /yh/* pages
  // useEffect(() => {
  //   if (!isYhPage) {
  //     setShowAnnouncement(true);
  //   }
  // }, [isYhPage]);

  const handleCloseAnnouncement = () => {
    setShowAnnouncement(false);
  };
  
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen" style={{ backgroundColor: '#eee' }}>
        <Helmet>
          <title>BizBuyMax.com - Buy and Sell Businesses</title>
          <meta name="description" content="Find businesses for sale, franchises, and business opportunities. Buy or sell your business with confidence." />
          <meta name="keywords" content="business for sale, buy business, sell business, franchise, business opportunity" />
        </Helmet>
        
        {!isSignInPage && <Header />}
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/businesses" element={<BusinessListings />} />
            <Route path="/franchises" element={<BusinessListings />} />
            <Route path="/business/:id" element={<BusinessDetails />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/firebase-test" element={<FirebaseTest />} />
            <Route path="/sell-business" element={<SellBusiness />} />
            <Route path="/account/listings/edit/:id" element={<EditListing />} />
            <Route path="/listing-submitted" element={<ListingSubmissionSuccess />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/account/dashboard" element={<AccountDashboard />} />
            <Route path="/account/listings" element={<AccountDashboard />} />
            <Route path="/account/leads" element={<AccountDashboard />} />
            <Route path="/account/profile" element={<AccountDashboard />} />
            <Route path="/account/saved-listings" element={<SavedListings />} />
            <Route path="/account/upgrades" element={<AccountDashboard />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/listings" element={<AdminListings />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="/admin/users/:id" element={<AdminUserDetail />} />
            <Route path="/admin/users/:id/edit" element={<AdminUserEdit />} />
            <Route path="/admin/listings/:id/edit" element={<AdminListingEdit />} />
            <Route path="/admin/conversations/:id" element={<AdminConversationView />} />
            <Route path="/brokers" element={<BrokersLanding />} />
            <Route path="/yh/list" element={<BrokeragesList />} />
            <Route path="/yh/bor" element={<BrokerOfRecordList />} />
            <Route path="/yh/sync" element={<DDFSyncTest />} />
          </Routes>
        </main>
        
        {!isSellBusinessPage && !isSignInPage && <Footer />}
        
        {/* Announcement Popup - hidden on /yh/* pages */}
        {!isYhPage && (
          <AnnouncementPopup 
            isOpen={showAnnouncement} 
            onClose={handleCloseAnnouncement} 
          />
        )}
      </div>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
